const initializeAmazonCtas = (root = document) => {
  const components = root.matches?.("[data-amazon-cta]")
    ? [root]
    : root.querySelectorAll?.("[data-amazon-cta]") ?? [];

  components.forEach((component) => {
    if (component.dataset.amazonCtaInitialized === "true") {
      return;
    }

    const variantMapElement = component.querySelector("[data-amazon-cta-variants]");
    const productForm = document.forms[component.dataset.formId];

    if (!variantMapElement || !productForm) {
      return;
    }

    const variantAsins = JSON.parse(variantMapElement.textContent);
    const label = component.dataset.label;
    const controller = new AbortController();
    const section = component.closest(".shopify-section");
    const buyButtons = productForm.closest("buy-buttons");

    const placeCtaAfterAddToCart = () => {
      const addToCartButton = buyButtons?.querySelector('button[type="submit"]');

      if (addToCartButton && addToCartButton.nextElementSibling !== component) {
        addToCartButton.after(component);
      }
    };

    const placementObserver = buyButtons ? new MutationObserver(placeCtaAfterAddToCart) : null;

    component.dataset.amazonCtaInitialized = "true";
    placeCtaAfterAddToCart();
    placementObserver?.observe(buyButtons, { childList: true });

    const updateCta = (variantId) => {
      const asin = variantId ? variantAsins[String(variantId)] : null;
      let link = component.querySelector("[data-amazon-cta-link]");

      if (!asin) {
        component.hidden = true;
        link?.remove();
        return;
      }

      if (!link) {
        link = document.createElement("a");
        link.className = "button w-full amazon-cta__link";
        link.dataset.amazonCtaLink = "";
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.textContent = label;
        component.append(link);
      }

      link.href = `https://www.amazon.com/dp/${encodeURIComponent(asin)}`;
      component.hidden = false;
    };

    productForm.addEventListener("variant:change", (event) => {
      updateCta(event.detail?.variant?.id);
    }, { signal: controller.signal });
    productForm.addEventListener("variant:selection-cleared", () => updateCta(null), { signal: controller.signal });

    section?.addEventListener("shopify:section:unload", () => {
      controller.abort();
      placementObserver?.disconnect();
    }, { once: true });
  });
};

initializeAmazonCtas();
document.addEventListener("shopify:section:load", (event) => initializeAmazonCtas(event.target));
